export enum INTERACTIVE_PRODUCT_TYPE {
    STANDALONE = 'interactiveStandalone',
    HYBRID = 'hybridMaterial'
}
